(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    if (event.target.closest('a[href]')) return;

    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    if (detailsToClose.length === 0) return;

    setTimeout(() => {
      for (const detailsElement of detailsToClose) {
        detailsElement.removeAttribute('open');
      }
    }, 100);
  });
})();

(function fixKonicaMinoltaTn613FamilyCard() {
  if (window.location.pathname !== '/collections/toner-konica-minolta') return;

  const imageUrl =
    'https://printmaster-8095.myshopify.com/cdn/shop/t/13/assets/konica-minolta-tn-613-cmybk.png';

  const applyFix = () => {
    const cards = [...document.querySelectorAll('.konica-minolta-family-card')];
    const card = cards.find((item) => item.textContent.includes('TN-613C / TN-413K') || item.textContent.includes('TN-613 C/M/Y/BK'));

    if (!card) return;

    const title = card.querySelector('.konica-minolta-family-card__title');
    const imageBox = card.querySelector('.konica-minolta-family-card__image');

    if (title) title.textContent = 'Konica Minolta TN-613 C/M/Y/BK';

    if (imageBox && !imageBox.querySelector('img[src*="konica-minolta-tn-613-cmybk.png"]')) {
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = 'Konica Minolta TN-613 C/M/Y/BK';
      image.width = 520;
      image.height = 360;
      image.loading = 'lazy';
      imageBox.replaceChildren(image);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix, { once: true });
  } else {
    applyFix();
  }

  setTimeout(applyFix, 800);
  setTimeout(applyFix, 2000);
})();
